import React from "react";
import { Card, Statistic } from "antd";
import { ShoppingCartOutlined } from "@ant-design/icons";

const TotalProfitCard = ({ orderMetrics }) => {
  // Get total orders from orderMetrics, default to 0 if not available
  const totalOrders = orderMetrics?.totalOrders || 0;
  
  return (
    <Card className="dashboard-card">
      <div className="justify-content-between align-items-center">
        <div className="d-flex align-items-center justify-content-between">
          <h5 className="card-title">TOTAL ORDERS</h5>
          <div className="icon-box purple">
          
          <ShoppingCartOutlined />
        </div>
         
        </div>

        <Statistic
          value={totalOrders}
          precision={0}
          valueStyle={{ color: "#6f42c1", fontWeight: "bold", fontSize: "24PX" }}
          />
      </div>
    </Card>
  );
};

export default TotalProfitCard;
